import { useEffect, useRef } from 'react';

// This is used to render html content in a shadow dom to avoid css conflicts and to encapsulate styles
export const ShadowContent = ({ html }: { html: string }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      const shadowRoot = container.attachShadow({ mode: 'open' });
      shadowRoot.innerHTML = html;
    }
  }, [html]);

  return <div ref={containerRef} />;
};
